import { render } from "./Products.vue?vue&type=template&id=e3bebe28"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=e3bebe28&lang=css"
script.render = render

export default script